import { useCallback, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  AppModal,
  AppRemixIcon,
  AppCheckbox,
  AppNoInfo,
} from '@/layout/AppComponents';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import AuxSidebar from '../../../../../Sidebar/AuxSidebar';
import { axiosPath } from '../../../../../../routing/helpers/router';
import useIsMounted from '../../../../../components/hooks/useIsMounted';

export default function SupervisionSidebarBlock() {
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const { moduleBridgeHex, plantHex, filtersHex } = useParams();
  const auxSidebar = useSelector(
    (state) => state.currentPage?.auxSidebar?.opened
  );
  const [openOnce, setOpenOnce] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [acceptCheckbox, setAcceptCheckbox] = useState(false);

  const handleAuxSidebar = () => {
    if (!openOnce) setOpenOnce(true);
    if (auxSidebar !== 'reports')
      dispatch(
        currentPageAction.change('auxSidebar', { opened: 'supervision' })
      );
    else dispatch(currentPageAction.change('auxSidebar', { opened: null }));
  };

  // > RESET SUPERVISION
  const resetSupervision = useCallback(() => {
    setShowModal(true);
    axios
      .post(
        axiosPath(
          "api_r_user_module_legalCompliance_correctiveActions_supervision_reset"
        ),
        {
          moduleBridgeHex,
          plantHex,
        }
      )
      .then((r) => {
        if (isMounted) {
          window.location.reload();
        }
      })
      .catch(() => alert("Ha habido un error"));
  }, [moduleBridgeHex, plantHex, filtersHex]);
  // < LOAD REPORT

  return (
    <>
      <li title="Reiniciar supervisión" onClick={() => handleAuxSidebar()}>
        <span className="sidebar-element">
          <AppRemixIcon icon="restart" className="sidebar-icon" />{' '}
          <span className="sb-title">Reiniciar supervisión</span>
        </span>
      </li>
      <AuxSidebar
        title="Reiniciar supervisión"
        isOpen={auxSidebar && auxSidebar === 'supervision'}
        width="350px"
        position="left"
        onClose={handleAuxSidebar}
      >
        {openOnce && (
          <>
            <div className="alert alert-info">
              ¿Seguro que quieres reiniciar todo el sistema de supervisión de
              esta instalación? Esta acción <b>no puede deshacerse</b>.
            </div>
            <AppCheckbox
              value={acceptCheckbox}
              onChange={(v) => setAcceptCheckbox(v)}
            >
              Si, quiero reiniciar toda la supervisión de esta instalación
            </AppCheckbox>
            <div className="row">
              <div className="col-lg-7 pr-1">
                <span
                  className="btn btn-sm btn-outline-danger btn-block"
                  onClick={() =>
                    dispatch(
                      currentPageAction.change('auxSidebar', { opened: null })
                    )
                  }
                >
                  Cancelar
                </span>
              </div>
              <div className="col-lg-5 pl-1">
                <span
                  className={`btn btn-sm btn-outline-info btn-block ${
                    acceptCheckbox ? '' : 'disabled'
                  }`}
                  onClick={() => acceptCheckbox && resetSupervision()}
                >
                  Reiniciar
                </span>
              </div>
            </div>
            <AppModal
              show={showModal}
              title="Reiniciando sistema de supervisión..."
              isCloseButton={false}
            >
              <AppNoInfo />
            </AppModal>
          </>
        )}
      </AuxSidebar>
    </>
  );
}
